import type { AccessToken } from "@okta/okta-auth-js";
import type { LocalToolsTokenSession } from "../models/localToolsTokenModels";
import { LOCAL_TOOLS_TOKEN_PROFILES } from "../models/oktaConstants";

// Only the deployed DEV and PROD pages offer the extension bridge.
// Local Codex already has direct local tools, and Stage has no approved remote proxy profile.
export const isLocalToolsTokenBridgeAllowed = (issuer: string, clientId: string): boolean => {
  const profile = LOCAL_TOOLS_TOKEN_PROFILES.find((entry) => entry.origin === window.location.origin);

  return profile !== undefined && profile.issuer === issuer && profile.clientId === clientId;
};

// Read only the access token already owned by the page's SDK.
// The gateway remains responsible for signature and permission checks; this projection never includes a refresh token.
// Preserve the expiry time even after sleep so the extension can wait for renewal instead of treating expiry as sign-out.
export const readLocalToolsTokenSession = (
  token: AccessToken | undefined,
  issuer: string,
  clientId: string,
  isLeader: boolean,
): LocalToolsTokenSession | null => {
  if (
    !isLocalToolsTokenBridgeAllowed(issuer, clientId) ||
    !token ||
    token.pendingRemove === true ||
    typeof token.accessToken !== "string" ||
    !token.accessToken ||
    typeof token.expiresAt !== "number" ||
    !Number.isFinite(token.expiresAt) ||
    typeof token.claims.sub !== "string" ||
    !token.claims.sub ||
    token.claims.iss !== issuer
  ) {
    return null;
  }

  return {
    accessToken: token.accessToken,
    expiresAt: token.expiresAt * 1000,
    issuer,
    clientId,
    subject: token.claims.sub,
    isLeader,
  };
};
